/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1200px){.Employee-timeControls .FormElement{margin-right:0}}.app-accountant-join .FormElement-label{white-space:nowrap;margin-right:.5em;margin-top:.5em}.accountant-join .k-grid-content{height:calc(100vh - 40rem);min-height:200px;overflow:auto}.accountant-join .k-grid table{width:100%!important}app-accountant-join .k-dialog-wrapper .k-content p{margin-left:0}"];
export { styles as styles };
